/**
 * Initial-document navigation snapshot (Issue #1136 Part 3, moved here in #3962).
 *
 * `performance.getEntriesByType('navigation')[0].type` describes the INITIAL
 * document load and never updates on SPA route changes, so ChatPage anchors it
 * to the pathname that was actually loaded before honouring a 'reload'.
 *
 * Why this is its own module: ChatPage used to capture these at its own module
 * load, which was page-load time while ChatPage was a static import. Since
 * #3962 ChatPage is a lazy chunk evaluated the first time a chat route renders,
 * so a capture inside it would record the CHAT pathname after any SPA
 * navigation, while the sticky 'reload' type still said the page was reloaded:
 * reload /dashboard, click into a resumed chat, and INITIAL_PATHNAME ===
 * the chat URL fires a false "Welcome back" toast. App.jsx imports this module
 * statically, so it is evaluated once, with the entry chunk, at page load.
 */
export const INITIAL_PATHNAME = typeof window !== 'undefined' ? window.location.pathname : '';
export const INITIAL_NAV_TYPE = (typeof performance !== 'undefined' &&
  typeof performance.getEntriesByType === 'function')
  ? performance.getEntriesByType('navigation')[0]?.type
  : null;
